<template>
	<div class="volunteer-home-online-training">
		<div class="online-training-box">
			<div class="ss-type-box">
				<div class="ss-type__text">
					<span v-for="(item, index) in typeList" @click="changeType(index)" :class="{'active': typeIndex === index}" :key="item.value">{{item.label}}</span>
				</div>
			</div>
			<div class="mt40">
				<ssTrainList :finish="finish_" :busy="busy_" :value="curData_" detailPath="/volunteerHome/elegantShow/" />
			</div>
		</div>
		<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
	</div>
</template>

<script>
	import ssTrainList from '@/components/ss-train-list/ss-train-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		data() {
			return {
				typeList: [{
					label: '文化志愿者',
					value: 'fczswhzyz'
				}, {
					label: '文化志愿者服务项目',
					value: 'fczswhzyzfwxm'
				}]
			}
		},
		components: {
			ssTrainList
		},
	}
</script>

<style lang="scss" scoped="scoped">
	.volunteer-home-online-training{
		.online-training-box{
			background-color: #fff;
			padding: 30px 35px;
			::v-deep .train-list{
				padding-right: 60px;
				.train-item{
					margin-right: 30px;
					width: 33.33333333%;
					&:nth-of-type(4n) {
						float: left;
						margin-right: 30px;
					}
					&:nth-of-type(3n) {
						float: right;
						margin-right: -60px;
					}
				}
			}
		}
	}
</style>
